import React, {useEffect, useMemo, useState} from 'react';

import type {
  CourseDefinitionContentResponse,
} from 'src/api/ProactApiClient';
import type {IFormDataV2} from 'src/types/FormV2';
import {QuizForm} from '../courseDefinition/QuizForm';

// timeLimit must only be added when set — an explicit `timeLimit: undefined`
// overrides the QuizForm metadata default (60) instead of falling back to
// it.
function buildQuizFormData(content: CourseDefinitionContentResponse) {
  return {
    ...content.quiz,
    ...(content.timeLimit === undefined ? {} : {timeLimit: content.timeLimit}),
  };
}

export interface EditContentDefinitionQuizProps {
  content: CourseDefinitionContentResponse;
  onContentChange: (content: CourseDefinitionContentResponse) => void;
}
const EditContentDefinitionQuiz: React.FC<EditContentDefinitionQuizProps> = ({
  content,
  onContentChange,
}) => {
  const [data, setData] = useState(buildQuizFormData(content));

  useEffect(() => {
    setData(buildQuizFormData(content));
  }, [content.quiz, content.timeLimit]);

  const handleFormDataChange = (data: IFormDataV2) => {
    onContentChange({
      ...content,
      timeLimit: data.timeLimit,
      quiz: {
        ...content.quiz!,
        headerText: data.headerText,
        bodyText: data.bodyText,
        scorePassPercentage: data.scorePassPercentage,
        enableGenerateCertificate: data.enableGenerateCertificate,
        enableShowCorrectAnswersInResults:
          data.enableShowCorrectAnswersInResults,
      },
    });
  };

  // Quiz-level fields only — the Build tab manages the question list itself
  // (Outline nested list + a per-question editor), so this component no
  // longer renders `EditContentDefinitionQuestions`.
  return useMemo(
    () => (
      <QuizForm
        data={data}
        mode="edit"
        onFormDataChange={handleFormDataChange}
      />
    ),
    [data]
  );
};

export default EditContentDefinitionQuiz;
